export default "__VITE_ASSET__Bst4IC2X__"